import { OperationLog } from 'common/models'
import { Dispatch, SetStateAction, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetchOperationLogItem } from 'store/internalControl/operationLog/actions'
import { FETCH_OPERATION_LOG_ITEM_SUCCESS } from 'store/internalControl/operationLog/constant'

import { OperationLogTarget, OperationLogType, UpdateChangeMode } from '../constant'
import { acceleratedEventLogStore, getAdjustHistory, resetAdjustHistory } from '../store/accelerated-log'

const UpdateTypes = [OperationLogType.UPDATE, OperationLogType.CORRECT, OperationLogType.CORRECT_FA]
const DeleteTypes = [OperationLogType.DELETE, OperationLogType.REMOVE]

export const useFetchOperationLogItem = (
  logItem: OperationLog | null,
  setViewUpdateMode: Dispatch<SetStateAction<UpdateChangeMode>>
) => {
  const dispatch = useDispatch()
  const adjustHistory = acceleratedEventLogStore.useSlice(state => state.data)

  useEffect(() => {
    if (adjustHistory?.fixed_asset) {
      dispatch({
        type: FETCH_OPERATION_LOG_ITEM_SUCCESS,
        payload: adjustHistory?.fixed_asset,
      })
    }
  }, [adjustHistory])

  useEffect(() => {
    if (!logItem) return

    setViewUpdateMode(UpdateChangeMode.BEFORE)
    const isAcceleratedEventMode = logItem.target === OperationLogTarget.ACCELERATED_EVENT
    if (!isAcceleratedEventMode) {
      const isUpdateOrDeleteType = [...UpdateTypes, ...DeleteTypes].indexOf(logItem.type) >= 0
      if (isUpdateOrDeleteType) {
        dispatch(fetchOperationLogItem(logItem.asset.biid, logItem.beforeId))
      } else {
        dispatch(fetchOperationLogItem(logItem.asset.biid, logItem.afterId))
      }
    } else {
      resetAdjustHistory()
      getAdjustHistory(logItem.id)
    }
  }, [logItem, setViewUpdateMode])
}
